import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { preparePortalLogin } from '../mobile/accountSession';
import { flushSessionVault } from '../mobile/sessionVault';

export default function ClientLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [stage, setStage] = useState("email"); // 'email' or 'password'
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const param = searchParams.get("email");
    if (param) {
      setEmail(param);
    }
  }, [searchParams]);

  const handleEmailSubmit = async () => {
    if (!email) return;
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/check-email/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      console.log("Response from check-email:", data);
  
      if (data.exists === true) {
        if (data.has_password === true) {
          setStage("password");
        } else {
          const normalizedEmail = email.trim().toLowerCase();
          sessionStorage.setItem('pendingClientEmail', normalizedEmail);
          navigate(`/set-password?email=${encodeURIComponent(normalizedEmail)}`, {
            state: { email: normalizedEmail },
          });
        }
      } else {
        setError("We couldn’t find a client account with that email.");
      }
    } catch (err) {
      console.error("Check email failed:", err);
      setError("Something went wrong. Please try again.");
    }
  };

  const handleLogin = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/client/login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (res.ok) {
        await preparePortalLogin('client');
        localStorage.setItem("clientToken", data.access);
        if (data.refresh) localStorage.setItem('clientRefreshToken', data.refresh);
        localStorage.setItem('clientCaseId', data.case_id);
        localStorage.setItem('clientEmail', data.email || email.trim().toLowerCase());
        await flushSessionVault();
        navigate("/client/dashboard");
      } else {
        setError(data.error || "Login failed.");
      }
    } catch (err) {
      setError("Login error.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center p-6">
      <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-xl">
        <img
          src="https://cisowskilaw.com/wp-content/uploads/2020/05/cropped-output-onlinepngtools-1-copy-63x63.png"
          alt="Logo"
          className="mx-auto h-12 w-12 mb-4"
        />
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-1">          Your Relief is Just Through These Doors!
        </h1>
        <p className="text-center text-sm text-gray-500 mb-6 italic">          The financial peace of mind attorney
        </p>

        {error && <p className="text-red-600 text-sm mb-4 text-center">{error}</p>}

        <form
          autoComplete="on"
          className="space-y-4"
          onSubmit={(event) => {
            event.preventDefault();
            if (stage === 'email') {
              handleEmailSubmit();
            } else {
              handleLogin();
            }
          }}
        >
          <input
            type="email"
            name="email"
            autoComplete="username"
            autoCapitalize="none"
            spellCheck={false}
            placeholder="Your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-indigo-500"
            readOnly={stage === "password"}
            required
          />

          {stage === "password" && (
            <input
              type="password"
              name="password"
              autoComplete="current-password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-indigo-500"
              required
            />
          )}

          <button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-md font-semibold"
          >
            {stage === "email" ? "Continue" : "Log In"}
          </button>

          <button
            type="button"
            onClick={() => navigate("/forgot-password")}
            className="w-full text-indigo-600 text-sm mt-2 hover:underline"
          >
            Forgot password?
          </button>
        </form>
      </div>
      <p className="text-xs text-gray-400 mt-6 text-center">
        &copy; {new Date().getFullYear()} Cisowski Law. All rights reserved.
      </p>
    </div>
  );
}
